import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from './../redux/hooks';
import { useTheme } from '../themeContext';

// -- Components 

import Notification from '../components/general/notification/Notification';
import Container from '../components/legal/Container';
import Page from '../components/general/containers/Page';


const Legal: React.FC = () => {

  const dispatch = useAppDispatch(); 

  const { isLightMode, toggleTheme } = useTheme();

  const colors = useAppSelector(state => state.theme.colors);


  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => { 

    if (isLightMode) {

      toggleTheme(); 

    }; 

  },[isLightMode]); 

  return (

    <Page>

      <Container />

    </Page>

  );
};

export default Legal;